var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "panelScoped", attrs: { fluid: "" } }, [
    _vm.appsLoaded
      ? _c(
          "div",
          { staticStyle: { "margin-top": "30px" } },
          [
            _vm.appNames.includes("SucursalVirtual") && _vm.valideSubDomain
              ? _c("btn-linked", {
                  attrs: {
                    link: "Mis-Solicitudes",
                    titulo: "SUCURSAL VIRTUAL",
                    srcs: "icono_sucursal_virtual"
                  }
                })
              : _vm._e(),
            false
              ? _c("btn-linked", {
                  attrs: {
                    link: "a",
                    titulo: "PAGAR EN LINEA",
                    srcs: "icono_pagar_en_linea"
                  }
                })
              : _vm._e(),
            _vm.appNames.includes("SucursalVirtual") && _vm.valideSubDomain
              ? _c("btn-linked", {
                  attrs: {
                    link: "Ver-Facturacion",
                    titulo: "FACTURAS PENDIENTES",
                    srcs: "icono_facturas_pendientes"
                  }
                })
              : _vm._e(),
            _vm.valideSubDomain
              ? _c("btn-linked", {
                  attrs: {
                    link: "https://certificados.gpschile.com/",
                    titulo: "EMITIR CERTIFICADO",
                    srcs: "icono_emitir_certificados",
                    clase: "background-size80"
                  }
                })
              : _vm._e(),
            false
              ? _c("btn-linked", {
                  attrs: {
                    link: "a",
                    titulo: "ACTUALIZACIÓN DE DATOS",
                    srcs: "icono_actualizacion_de_datos"
                  }
                })
              : _vm._e()
          ],
          1
        )
      : _vm._e(),
    _c(
      "div",
      {
        staticClass: "imgPublicidad",
        staticStyle: { "margin-top": "20px", width: "60%" }
      },
      [
        _c("v-img", { attrs: { src: require("../assetsHome/publicidad.png") } })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }